import React from 'react'
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { PageContainerToolbar } from '@toolpad/core/PageContainer'
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import { useDispatch, useSelector } from 'react-redux';
import OutlinedInput from '@mui/material/OutlinedInput';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { setAccountModalOpen, setCompany,get_company_users,setSearchQuery, setPage } from '../../../store/account/accountSlice';
import { ACCOUNT_LIMIT } from '../../../helpers/constants';
import { setAction } from '../../../store/account/accountSlice';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import { Tooltip } from '@mui/material';

const AccountPageToolBar = () => {
  const dispatch = useDispatch();

  const { 
    selected_company,
    is_account_modal_open, 
    company_list,
    search_query,
    active_users,
    total_users_count,
    page
  } = useSelector((state) => state.account);
  
  const handleCompanyChange = (event) => {
    const { value } = event.target;
    const newVal = value === undefined ? "" : value;
    const qn = search_query;
    dispatch(setPage(null));
    const params = {
      qc : value,
      page : page+1,
      limit : ACCOUNT_LIMIT 
    };
    if (qn) {
      params.qn = qn; 
    }    
    dispatch(setCompany(newVal));
    dispatch(get_company_users(params));
  };

  const handleSearchChange = () => {   
    const qn = search_query;
    const qc = selected_company;
    dispatch(setPage(null));
    const params = { qn,page:1,limit:ACCOUNT_LIMIT };
    if (qc) {
      params.qc = qc; 
    }
    dispatch(get_company_users(params))
  }; 

  const handleClearSearch = () => {
    dispatch(setSearchQuery("")); 
    const qc = selected_company; 
    const params = { 
      page : page+1,
      limit : ACCOUNT_LIMIT 
    };
    if (qc) {
      params.qc = qc; 
    }    
    dispatch(get_company_users(params)); 
  };

  const handleAccountModal = (c_action) => {
    dispatch(setAccountModalOpen(!is_account_modal_open));
    dispatch(setAction(c_action))
  };

  return (
    <PageContainerToolbar sx={{display:'flex', justifyContent : 'space-between', marginLeft: 0, width: '80vw', flexDirection : {lg:'row', md:'column', xs:'column'} }}>
      <Tooltip title={`Active: ${active_users} / ${total_users_count}`}arrow>
          <Typography variant="subtitle2" fontWeight={500}
          display='flex' sx={{
          alignItems : {md:'center',xs:'flex-start'},
        }}
          >
            {`Active: ${active_users} / ${total_users_count}`}
          </Typography>
        </Tooltip>
      <Box display='flex' sx={{
        flexDirection : {lg:'row', md:'column', xs:'column'},
        alignItems : {md:'center',xs:'flex-start'}
      }}>
        
        <Box sx={{
          '& .MuiFormControl-root,.MuiButtonBase-root':{
            mx:{md:1,xs:0}
          },
          '& .MuiFormControl-root' : {
           my:{lg:0,md:0.8,xs:0.8}
          },
          '& .actionButton':{
            display : {md:'flex',xs:'none'}
          },
          width : {md:'unset',xs:'100%'},
          display : 'flex',
          flexDirection : {lg:'row', md:'column', xs:'column'},
          alignItems:'center'
        }}>
        <Typography variant='subtitle2' color='textPrimary' fontWeight='500'>Filter By:</Typography>

          <FormControl size='small' 
          sx={{
            minWidth:{md:240,xs:'100%'},
            maxWidth: {md:200,xs:'100%'},
            '& .MuiOutlinedInput-input' : {
              fontSize : '14px',
            },
            '& .MuiOutlinedInput-root' : {
              paddingRight : '0px'
            },
            '& .MuiButtonBase-root' : {
              marginRight : '0px',
              marginLeft : '0px',
              borderTopLeftRadius:'0px',
              borderBottomLeftRadius:'0px'
            }
          }}
          >
            <OutlinedInput 
            value={search_query} 
            onChange={(e) => {
              const query = e.target.value;
              dispatch(setSearchQuery(query));
              if (query === "") {
                handleClearSearch();
              }
            }}             
            placeholder="User name" 
            onKeyUp={(event) => {
              if (event.key === "Enter") {
                handleSearchChange(); 
              }
            }}            
            endAdornment={
              <InputAdornment position="end">
              {search_query.length > 0 && (
                <IconButton
                  size="small"
                  onClick={handleClearSearch}
                >
                  <ClearIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              )}
              <IconButton 
                onClick={handleSearchChange}
                sx={{ padding: 0, margin: '5px' }}
              >
                <ChevronRightIcon/>
              </IconButton>
            </InputAdornment>
          }
        />
          </FormControl>
          {
          (company_list.length > 0) && (
          <FormControl 
          sx={{minWidth:{lg:200,md:'95%',xs:'100%'},maxWidth: {lg:180,md:'90%',xs:'100%'} }}>
            <Select
              endAdornment = {
                selected_company && (
                <InputAdornment position='end'>
                <IconButton 
                size='small' 
                onClick={handleCompanyChange} 
                sx={{mr:-1.5}}>
                  <ClearIcon sx={{fontSize:'20px'}} />
                </IconButton>
                </InputAdornment>
                )
              }
                value={selected_company}
                size='small'
                onChange={handleCompanyChange}
                displayEmpty
                sx={{
                  fontSize:'13px',
                  "& .MuiOutlinedInput-input" : {
                    padding : "10px 14px",
                    paddingRight : selected_company ? '0px!important' : '32px'
                  },
                  "& .MuiSelect-icon" : {
                    display : selected_company ? 'none' : 'block',
                  },
                }}
              >
                <MenuItem disabled value="" sx={{fontSize:'14px', height: '25px'}}>
                  <p>Select a company</p>
                </MenuItem>
                {
                  company_list.map((company,idx) => {
                    return (
                      <MenuItem value={company.id} sx={{fontSize:'14px', height: '25px'}} key={idx}>{company.name}</MenuItem>
                    )
                  })
              }
            </Select>
          </FormControl>
            )
          }
          <Button
            onClick={() => handleAccountModal('CREATE')}
          >
            <Box sx={{ '& > :not(style)': { m: 0 } }}>
              <Fab size="small" color="primary" aria-label="add">
                <AddIcon />
              </Fab>
            </Box>
          </Button>
          <Button className='actionButton' variant='contained' disableElevation>
            <SimCardDownloadOutlinedIcon htmlColor='white'/>
          </Button>
        </Box>
      </Box>
      </PageContainerToolbar>
  )
}

export default AccountPageToolBar;